import { render } from "./OldestRecords.vue?vue&type=template&id=4c21436b&scoped=true&ts=true"
import script from "./OldestRecords.vue?vue&type=script&lang=ts"
export * from "./OldestRecords.vue?vue&type=script&lang=ts"

import "./OldestRecords.vue?vue&type=style&index=0&id=4c21436b&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4c21436b"]])

export default __exports__